import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

const NICOTINE_OPTIONS = [
    { value: "false", label: "No" },
    { value: "true", label: "Yes" },
];

interface NicotineUsageFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    value?: string;
    disabled?: boolean;
    id?: string;
    fullWidth?: boolean;
}

const NicotineUsageField = ({ register, error, value, disabled = false, id, fullWidth = true }: NicotineUsageFieldProps) => {
    const width = fullWidth ? "w-full" : "w-[176px] tablet:w-[190px]";

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // Call the register's onChange first
        if (register.onChange) {
            register.onChange(e);
        }
        // Trigger validation immediately when a value is selected
        if (register.onBlur) {
            register.onBlur({ target: { name: register.name, value: e.target.value } } as any);
        }
    };

    return (
        <div className={`form-control flex-1 ${width}`}>
            <label className="label min-h-7" htmlFor={id}>
                <span className="text-base-content">In the last 12 months, have you used nicotine in any form?</span>
            </label>
            <select
                {...register}
                onChange={handleChange}
                id={id}
                value={value || ""}
                className={`select select-bordered bg-base-100 h-9 min-h-9 text-sm ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${error ? "select-error" : ""} ${!value ? "text-gray-400" : ""}`}
                disabled={disabled}
            >
                <option value="" disabled>
                    Select
                </option>
                {NICOTINE_OPTIONS.map((option) => (
                    <option key={String(option.value)} value={String(option.value)} className="text-base-content">
                        {option.label}
                    </option>
                ))}
            </select>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default NicotineUsageField;
